import { ApiUrls } from '@api/apiUrls';
import { fetchApi, FetchApiResponse } from '@api/fetchApi';

export interface IApiTradingAccountUserSettings {
  canCreateRealAccountForNonApproved: boolean;
  canCreateDemoAccountForNonApproved: boolean;
}

export const apiTradingAccountUserSettings = {
  getAccountCreationSettings: async (): Promise<FetchApiResponse<IApiTradingAccountUserSettings>> => {
    return await fetchApi.get(ApiUrls.userTradingAccountSettings.getAccountCreationSettings);
  },
};
